<template>
	<div class="recharge_prompt shade">
		<div class="prompt-box">
			<div class="header">
				<p class="title">提示</p>
				<p class="text">订单需支付<span>{{all_money}}</span>元</p>
			</div>
			<div class="content">
				<div class="number" v-if="!environment">
					<span>使用</span><span class="reduce" @click="reduceMoney"></span><input type="text"  v-model="deduction_money" class="count" @keyup="filterDeductionCount()"/><span class="add" @click="addMoney"></span><span>钻石</span>
				</div>
				<div class="money" v-if="!environment">还需支付：<span>{{pay_money}}</span>元</div>
				<div class="youkuMsg" v-if="currentIndex==1&&!environment">优酷会员将会充值到您输入的手机号码，若该号码未注册将自动为您注册优酷，请确认该号码是否已设置密码或可接受短信验证码。</div>
				<div class="pay_type" v-if="environment">
					<div class="wx" @click="chooseWX()">
						<span class="text" :class="isChoosed==0 ? 'checked' : 'unchecked'">微信支付</span>
					</div>
					<div class="alipay" @click="chooseALI()">
						<span class="text" :class="isChoosed==1 ? 'checked' : 'unchecked'">支付宝支付</span>
					</div>
				</div>
			</div>
			<div class="footer">
				<div class="cancel" @click="close">取消</div>
				<div class="sure-btn" @click="sure">确定</div>
			</div>
		</div>


	</div>
</template>

<script>
	import {rechargeParam} from '../assets/js/common.js'

	let count = 0;
	
	export default{
		props:{
			payInfo:{
				type:Object
			}
		},
		data(){
			return {
				all_money:0,
				deduction_money:0,
				pay_money:0,
				rmb:0,
				isDeduction:{},
				pay_type:'',
				isChoosed:0,
				currentIndex:0,

			}
		},
		watch:{
			payInfo:function(){
				this.all_money = Number(this.payInfo.price).toFixed(2);
				this.pay_money = Number(this.payInfo.price).toFixed(2);
				this.rmb = this.payInfo.rmb.split(".")[0];
				this.currentIndex=this.payInfo.currentIndex;
			}
		},
		created(){
		},
		methods:{
			chooseWX(){
				this.isChoosed = 0;
				this.pay_type = 'WEIXINH5';
			},
			chooseALI(){
				this.isChoosed = 1;
				this.pay_type = 'ALIPAY';
			},
			close(){
				this.deduction_money = 0;
				this.$emit("closePay");
			},
			reduceMoney(){
				if(this.filterDeductionCount()){
					if(Number(this.deduction_money) > 0){
						count = this.deduction_money;
						count --;
						this.deduction_money = count;
						this.pay_money = parseFloat(Number(this.all_money) - Number(this.deduction_money)).toFixed(2);
					}
				}
			},
			addMoney(){
				if(this.filterDeductionCount()){
					this.pay_money = parseFloat(Number(this.all_money) - Number(this.deduction_money)).toFixed(2);
					if(Number(this.deduction_money) < Number(this.rmb) && Number(this.deduction_money) < Number(this.all_money.split('.')[0])){
						count = this.deduction_money;
						count ++;
						this.deduction_money = count;
						this.pay_money = parseFloat(Number(this.all_money) - Number(this.deduction_money)).toFixed(2);
//						this.pay_money = parseInt(this.all_money)-parseInt(this.deduction_money)+"."+this.all_money.split('.')[1];
					}
				}
				
			},
			sure(){
				if(this.environment && this.isChoosed == 0){
					this.pay_type = 'WEIXINH5';
				}else if(this.environment && this.isChoosed == 1){
					this.pay_type = 'ALIPAY';
				}else{
					this.pay_type = 'WEIXIN';
				}
				
				this.pay_money = (Number(this.all_money)*100 - Number(this.deduction_money)*100)/100;

				if(this.deduction_money == ''){
					this.deduction_money = 0;
				}
				if(this.filterDeductionCount()){
					this.isDeduction = {
						dedution:true,
						money:this.deduction_money,
						pay_type:this.pay_type
					}
					this.pay_money = (Number(this.all_money)*100 - Number(this.deduction_money)*100)/100;
					this.$emit("confirm_pay",this.isDeduction);
					
					this.deduction_money = 0;
				}
			},
			filterDeductionCount(){
				if((!(/^([1-9]\d*|[0]{1,1})$/).test(this.deduction_money)) && this.deduction_money!=''){
					alert("请输入合法的抵扣数");
					this.pay_money = this.all_money;
					return false;
						 }
						 
				if(Number(this.deduction_money) > Number(this.rmb)){
					alert("您的钻石余额不足");
					this.pay_money = this.all_money
					return false;
				}

					if(Number(this.deduction_money) > Number(this.all_money.split('.')[0])){
						alert("抵扣不能大于金额");
						this.pay_money = this.all_money
						return false;
					}
				this.pay_money = this.Subtr(this.all_money,this.deduction_money) 
				return true;
				
			},
			Subtr(arg1,arg2){ 
			 var r1,r2,m,n; 
			 try{r1=arg1.toString().split(".")[1].length}catch(e){r1=0} 
			 try{r2=arg2.toString().split(".")[1].length}catch(e){r2=0} 
			 m=Math.pow(10,Math.max(r1,r2)); 
			 n=(r1>=r2)?r1:r2; 
			 return ((arg1*m-arg2*m)/m).toFixed(n); 
			}
		},
		computed:{
			
		}
	}
</script>

<style scoped="scoped">
	/*遮罩层*/
	.shade{ 
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: url(../assets/img/shade-bg@2x.png) no-repeat;
		background-size: 100%;
	}
	.prompt-box{
		position: absolute;
		top: 50%;
		left: 50%;
		margin-left: -3.5rem;
		margin-top: -3.265rem;
		width: 7rem;
		height: 6.53rem;
		background: url(../assets/img/dialog-bg@2x.png) no-repeat;
		background-size: 100%;
	}
	.header{
		width: 100%;
		height: 1.46rem;
	}
	.header .title{
		padding: 0.18rem 0 0.1rem;
		text-align: center;
		font-size:0.48rem;
		font-family:PingFangSC-Medium;
		font-weight:500;
		color:rgba(51,51,51,1);
	}
	.header .text{
		text-align: center;
		font-size:0.24rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(78,78,78,1);
	}
	.content{
		width: 100%;
		height: 3.73rem;
		overflow: scroll;
	}
	.content .number{
		margin: 0.4rem 0 0.3rem;
		width: 100%;
		height: 0.62rem;
		line-height: 0.62rem;
		text-align: center;
		font-size:0.24rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(78,78,78,1);
		box-sizing: border-box;
	}
	.content .number span{
		vertical-align: middle;
	}
	.content .number .reduce{
		margin: 0 0.16rem 0 0.36rem;
		display: inline-block;
		width: 0.6rem;
		height: 0.6rem;
		background: url(../assets/img/reduce_rmb@2x.png) no-repeat;
		background-size: 100%;
	}
	.content .number .count{
		display: inline-block;
		width: 1.22rem;
		height: 0.62rem;
		background: url(../assets/img/rectangle@2x.png) no-repeat;
		background-size: 100%;
		border: none;
	    outline: none;
	    text-align: center;
	}
	.content .number .add{
		margin: 0 0.36rem 0 0.16rem;
		display: inline-block;
		width: 0.6rem;
		height: 0.6rem;
		background: url(../assets/img/add_rmb@2x.png) no-repeat;
		background-size: 100%;
	}
	.content .money{
		text-align: center;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(78,78,78,1);
	}
	.content .youkuMsg{
		margin-top:0.3rem;
		text-align: left;
		font-size:0.25rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(151,151,151,1);
		padding:0 0.3rem;
	}
	.content .pay_type{
		margin-top: 0.86rem;
		display: flex;
		font-size:0.3rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(78,78,78,1);
	}
	.content .pay_type .text{
		padding-left: 1.24rem;
		padding-right: 0.4rem;
	}
	.content .pay_type .wx{
		flex: 1;
		height: 0.44rem;
		background: url(../assets/img/wx_icon@2x.png) no-repeat 0.64rem center;
		background-size: 0.44rem;
	}
	.content .pay_type .alipay{
		flex: 1;
		height: 0.44rem;
		background: url(../assets/img/alipay_icon@2x.png) no-repeat 0.64rem center;
		background-size: 0.44rem;
	}
	.content .pay_type .text.checked{
		background: url(../assets/img/pay_choosed@2x.png) no-repeat right center;
		background-size: 0.3rem;
	}
	.content .pay_type .text.unchecked{
		background: url(../assets/img/pay_unchoosed@2x.png) no-repeat right center;
		background-size: 0.3rem;
	}
	.footer{
		display: flex;
	}
	.footer .cancel,.footer .sure-btn{
		flex: 1;
		height: 1.3rem;
		line-height: 1.3rem;
		font-size:0.36rem;
		font-family:PingFangSC-Regular;
		font-weight:400;
		text-align: center;
	}
	.footer .cancel{
		color:rgba(51,51,51,1);
	}
	.footer .sure-btn{
		color:rgba(42,137,255,1);
	}
</style>


// WEBPACK FOOTER //
// src/components/pay_prompt.vue